import type { AgendaTypes } from "../../utils/types/pagesTypes"
import { GLOBAL_FILTER_IDENTIFIER } from "./reducer"

export const LoadingState = {
    Loading: "loading",
    Success: "success",
    Error: "error",
}

export type LoadingStateType = (typeof LoadingState)[keyof typeof LoadingState]

export type FiltersIdentifier = AgendaTypes | CustomFiltersIdentifiers | typeof GLOBAL_FILTER_IDENTIFIER

export type FiltersObject = Record<string, FilterValue>

export type FilterValue = any

export enum CustomFiltersIdentifiers {
    Promotions = "promotions",
    GoogleReviews = "googleReviews",
}
